import React from 'react';
import {
  Text,
  TokenTextAppearance,
  TextTag,
  styled,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';

type Props = {
  name: string;
  hex: string;
  label?: string;
};

interface HexExteriorColorStyledInterface {
  hexValue: string;
}

export const HexExteriorColorStyled = styled.div<HexExteriorColorStyledInterface>`
  margin: -0.11em 0 0.11em 0;
  margin-right: ${(props) => props.theme.size.static150};
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: ${(props) => props.hexValue} !important;
  ${(props) =>
    props.hexValue === '#ffffff'
    ? `border: 1px solid black;`
    : undefined
  }
`;

const ColorDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ColorDetailLine = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  align-items: center;
  justify-content: flex-start;
`;

const ColorTitle = styled.div`
    color: #6C787F;
`;

const ColorDetail = ({name, hex, label}: Props) => {
  return (
    <ColorDetailContainer>
        {label && (
          <ColorTitle>
            <Text appearance={TokenTextAppearance.copy100} bold color={TokenTextColor.inherit}>
              {label}
            </Text>
          </ColorTitle>
        )}
      <ColorDetailLine>
        <HexExteriorColorStyled hexValue={hex} role="presentation" />
        <Text tag={TextTag.span} appearance={TokenTextAppearance.copy200}>
          {name}
        </Text>
      </ColorDetailLine>
    </ColorDetailContainer>
  );
};

export default ColorDetail;
